module.exports = __webpack_public_path__ + "static/media/hero01.233e3a32.jpg";